import React from "react";
import { ListEmptyComponent } from "./styles";

interface ListEmptyProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function ListEmpty({ children, ...props }: ListEmptyProps) {
  return <ListEmptyComponent {...props}>{children}</ListEmptyComponent>;
}
